import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, getPrizeRestrictionListRequest } from "../../../api/controller/QuizController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const quizListState = atom({
    key: 'quizListState',
    default: [],
})
export const quizPrizeRestrictionState = atom({
	key: 'quizPrizeRestrictionState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const filtersDefault = []

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const quizDataStructureState = selector({
    key: 'quizDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Name',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Start Date',
                type: 'datepicker',
                order: { table: 2, form: 2 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'End Date',
                type: 'datepicker',
                order: { table: 3, form: 3 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Answerable Duration',
                type: 'number',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Question Type',
                type: 'select',
                order: { form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				rootValue: true,
				list: {
					ovf: false,
					data:[
						{ label: 'Text', value: 'Text' },
						{ label: 'Image', value: 'Image' },
						{ label: 'Text & Image', value: 'Text & Image' },
					]
				},
            },
			{ 
                label: 'Option Type',
                type: 'select',
                order: { form: 6 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				rootValue: true,
				list: {
					ovf: false,
					data:[
						{ label: 'Text', value: 'Text' },
						{ label: 'Image', value: 'Image' },
						{ label: 'Text & Image', value: 'Text & Image' },
					]
				},
            },
			{ 
                label: 'Quiz Language',
                type: 'select',
                order: { table: 5, form: 7 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				rootValue: true,
				list: {
					ovf: false,
					data:[
						{ label: 'English', value: 'English' },
						{ label: 'Dhivehi', value: 'Dhivehi' },
					]
				},
            },
			{ 
                label: 'Active',
                type: 'switch',
                order: { table: 6, form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },
			{ 
                label: 'Prize Restrictions',
                type: 'multiselect',
                order: { form: 9 }, 
                subFields: { label: 'display_name', value: 'id'},
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(quizPrizeRestrictionState),
				getRequest: getPrizeRestrictionListRequest,
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
